module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index information"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": _vm.handleAddFinancialDocument
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить документ\n      ")])]), _vm._v(" "), (_vm.fDocuments.length) ? _c('div', {
    staticClass: "documents"
  }, [_c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveFinancialDocuments()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('draggable', {
    staticClass: "fake-table",
    model: {
      value: (_vm.documentsData),
      callback: function($$v) {
        _vm.documentsData = $$v
      },
      expression: "documentsData"
    }
  }, _vm._l((_vm.documentsData), function(document) {
    return _c('DocumentItem', {
      key: document.id,
      attrs: {
        "document": document
      }
    })
  }), 1)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Документ")]), _vm._v(" "), _c('td', [_vm._v("Дата расчета")]), _vm._v(" "), _c('td', [_vm._v("Дата раскрытия")]), _vm._v(" "), _c('td', [_vm._v("Период актуальности информации")]), _vm._v(" "), _c('td', [_vm._v("Дата скрытия")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333877d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/Information.vue
// module id = 925
// module chunks = 0